// Function to scroll the window smoothly to the target position with a specific duration
function smoothScrollTo(targetPosition, duration) {
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  const startTime = performance.now();

  function scrollStep(timestamp) {
    const currentTime = timestamp - startTime;
    const scrollFraction = currentTime / duration;

    if (currentTime >= duration) {
      window.scrollTo(0, targetPosition);
    } else {
      const easeValue = 0.5 * (1 - Math.cos(Math.PI * scrollFraction));
      const scrollY = startPosition + distance * easeValue;
      window.scrollTo(0, scrollY);
      requestAnimationFrame(scrollStep);
    }
  }

  requestAnimationFrame(scrollStep);
}


